module.exports = __webpack_public_path__ + "img/toyota.5da851e8.png";